import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form, Input, message, Modal, Table } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SvgCom from '../../components/SvgCom/index.jsx';
import { ReactComponent as EditSvg } from '../../assets/svgs/edit.svg';
import { ReactComponent as DownloadSvg } from '../../assets/svgs/download.svg';
import { ReactComponent as ShareSvg } from '../../assets/svgs/share.svg';
import { ReactComponent as DeleteSvg } from '../../assets/svgs/delete.svg';
import { deleteShowreel, getShowreelList, putShowreel } from '../../api/request.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { copyToClipboard } from '../../utils/utils.js';
import {ReactComponent as CloseSvg} from '../../assets/svgs/close.svg';

const ShowreelPage = () => {
  const nvigate = useNavigate();
  const [dataList, setDataList] = useState([]);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(1);
  const [loading, setLoading] = useState(false);
  const [ showWin, setShowWin] = useState(false);
  const [ curRowId, setCurRowId ] = useState('');
  const [queryParams] = useSearchParams();
  const filter = queryParams.get('filter') || '';

  const columns = [
    {
      title: '',
      width: 150,
      dataIndex: 'projectId',
      key: 'projectId',
      fixed: 'left',
      align: 'center',
      render: (value) => {
        return <img src={value} alt="" className='w-[42px]' />;
      }
    },
    {
      title: 'Name',
      dataIndex: 'title',
      key: 'title',
      align: 'left',
      minWidth: 300,
      render: (value) => {
        return <div className='flex flex-col justify-start items-start'>
          <div className='text-[14px] font-semibold'>{value}</div>
          {/* <div className='text-[12px] font-normal opacity-40'>Unilever Consumer Theatre (Attitude&Lifestyle) UK,US UGN2...</div> */}
        </div>;
      }
    },
    {
      title: 'Status',
      width: 150,
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (value) => {
        return <div className='text-center py-[5px] px-[15px] inline-block rounded-xl bg-second' onClick={fnOpenDetail}>
          {value}
        </div>;
      }
    },
    {
      title: 'Clips',
      width: 100,
      dataIndex: 'items_count',
      key: 'items_count',
      align: 'center'
    },
    // {
    //   title: 'Length',
    //   width: 200,
    //   dataIndex: 'length',
    //   key: 'length',
    //   align: 'center',
    //   render: () => {
    //     return '02:25';
    //   }
    // },
    {
      title: 'Last update',
      width: 200,
      dataIndex: 'updated_at',
      key: 'updated_at',
      align: 'center'
    },
    {
      title: '',
      width: 100,
      dataIndex: 'actions',
      key: 'actions',
      align: 'center',
      render: (_, row) => {
        return <div className='flex items-center'>
          <SvgCom onClick={(e) => rowBtnClick(e, 'share', row)}  Svg={ShareSvg} size="16" className="cursor-pointer hover:text-green-1 text-primary"></SvgCom>
          <SvgCom onClick={(e) => rowBtnClick(e, 'download', row)} Svg={DownloadSvg} size="16" className="ml-2 cursor-pointer hover:text-green-1 text-primary"></SvgCom>
          <SvgCom onClick={(e) => rowBtnClick(e, 'edit', row)} Svg={EditSvg} size="16" className="ml-2 cursor-pointer hover:text-green-1 text-primary"></SvgCom>
          <SvgCom onClick={(e) => rowBtnClick(e, 'delete', row)} Svg={DeleteSvg} size="16" className="ml-2 cursor-pointer hover:text-green-1 text-primary"></SvgCom>
        </div>;
      }
    },
  ];

  const fnDeleteShowreel = (id) => {
    Modal.confirm({
      title: 'Warning',
      icon: <ExclamationCircleOutlined />,
      content: 'Do you want to delete this record?',
      okText: 'Entry',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await deleteShowreel(id);
          getDataList();
        } catch(error) {
          //
        } finally {
          //
        }
      }
    });
  };

  const rowBtnClick = async(e, type, row) => {
    e.stopPropagation();
    const id = row.id;
    if(type === 'share') {
      try {
        const link = window.location.href;
        await copyToClipboard(`${link}/detail/${id}`);
        message.success('Copid');
      } catch(error) {
        //
      }
    } else if(type === 'download') {
      //
    } else if(type === 'edit') {
      setShowWin(true);
      setCurRowId(id);
    } else {
      fnDeleteShowreel(id);
    }
  };

  const fnOpenDetail = (id) => {
    nvigate('/consumer-theatre-processing/showreel/detail/'+id);
  };

  const paginateChange = (pagination) => {
    const {current} = pagination;
    setCurrent(current);
  };

  /**
   * get project list
   */
  const getDataList = useCallback(async() => {
    try {
      setLoading(true);
      const params = {
        page: current,
        page_size: 10,
        sort: '-created_at',
        search: filter
      };
      const response = await getShowreelList(params);
      const {  status, data = {}, message = '' } = response || {};
      if(status === 'Success') {
        const { items = [], total = 0 } = data;
        setTotal(total);
  
        setDataList(items);
      } else {
        throw new Error(message || 'service error');
      }
    } catch(error) {
      message.error(error?.message || error?.msg || 'service error');
    } finally {
      // end handler
      setLoading(false);
    }
  }, [current, filter]);
  
  useEffect(() => {
    getDataList();
  }, [getDataList]);

  // modify name
  const [newName, setNewName] = useState('');
  const fnCloseWin = () => {
    setShowWin(false);
  };

  const fnEntry = async () => {
    try {
      const title = newName.trim();
      if(!title) return;
      const params = {
        title: title
      };
      const result = await putShowreel(curRowId, params);
      if(result.status === 'Success') {
        getDataList();
        setShowWin(false);
      }
    } catch(error) {
      //
    } finally {
      // 
    }
  };

  return (
    <div className="px-[30px] py-[30px]">
      <Table
        rowKey="id"
        loading={loading}
        className="ctp-table"
        bordered={false}
        columns={columns}
        dataSource={dataList}
        onChange={paginateChange}
        onRow={(record) => {
          return {
            onClick: () => fnOpenDetail(record.id), // 点击行
          };
        }}
        pagination={
          {
            current,
            pageSize: 10,
            total,
            showSizeChanger: false
          }
        }
        scroll={{ x: 'max-content', y: 'calc(100% - 240px)'}}
      />

      <Modal open={showWin} width="30%" destroyOnClose onCancel={fnCloseWin} closeIcon={<SvgCom Svg={CloseSvg} size='20'></SvgCom>} footer={null} centered={true} classNames={{
        content: '!p-[18px]',
      }}>
        <div className='text-primary'>
          <div className='text-[14px] font-semibold leading-none mb-5'>Modify showreel name</div>
          <Form
            name="basic"
            layout="vertical"
            autoComplete="off"
            className='add-showreel-form'
          >
            <Form.Item
              label="Showreel name"
              name="Showreel name"
            >
              <Input value={newName} onChange={(e) => setNewName(e.target.value.trim())} />
            </Form.Item>
     
            <Form.Item label={null}
              className='flex justify-end'
            >
              <Button onClick={fnEntry} type="primary" htmlType="submit" className='ml-3'>
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default ShowreelPage;